import { useEffect, useState } from 'react';
import { useFetch } from 'loti-request/module';
import type { ChildrenParams, FetchOptions } from 'loti-request/module/useFetch';

const usePersistentFetch = <T>({
  onSuccess,
  onError,
  ...options
}: FetchOptions<T>): ChildrenParams<T> => {
  const [persistentData, setPersistentData] = useState<T | undefined>(undefined);

  const { data, status, ...rest } = useFetch<T>({
    ...options,
    onSuccess: (response, params) => {
      setPersistentData(response);
      if (onSuccess) {
        onSuccess(response, params);
      }
    },
    onError: (error, statusCode, params) => {
      if (onError) {
        onError(error, statusCode, params);
      }
    }
  });

  useEffect(() => {
    if (data && persistentData === undefined) {
      setPersistentData(data);
    }
  }, [data, persistentData]);

  return {
    data: status === 'FAILED' ? data : data ?? persistentData,
    status,
    ...rest
  };
};

export { usePersistentFetch };
